/* eslint-disable import/no-anonymous-default-export */
export default [
    // Our Angi Coupon
    {
        id: "KEOzTawo",
        amount_off: null,
        currency: null,
        duration: "forever",
        duration_in_months: null,
        durationInMonths: null,
        max_redemptions: null,
        metadata: {},
        name: "ANGI ONLY PACKAGE",
        percent_off: 60.1,
        percentOff: 60.1,
        redeem_by: null,
    },
    // Our Default Coupon
    {
        id: "GrPPdkt1",
        amount_off: null,
        currency: null,
        duration: "repeating",
        duration_in_months: 3,
        durationInMonths: 3,
        max_redemptions: null,
        metadata: {},
        name: "60% off for 3 mos",
        percent_off: 60.1,
        percentOff: 60.1,
        redeem_by: null,
    },
    {
        id: "xzlHZd27",
        amount_off: null,
        currency: null,
        duration: "repeating",
        duration_in_months: 3,
        durationInMonths: 3,
        max_redemptions: null,
        metadata: {},
        name: "50% off for 3 mo, with 30-day trial",
        percent_off: 50,
        percentOff: 50,
        redeem_by: null,
    },
    {
        id: "test-oct-2024",
        amount_off: null,
        currency: null,
        duration: "once",
        duration_in_months: null,
        durationInMonths: null,
        max_redemptions: 10,
        metadata: {},
        name: "TESTING OCT 2024",
        percent_off: 100,
        percentOff: 100,
        redeem_by: null,
    },
    {
        id: "8P1zedSS",
        amount_off: null,
        currency: null,
        duration: "forever",
        duration_in_months: null,
        durationInMonths: null,
        max_redemptions: null,
        metadata: {},
        name: "15% Discount",
        percent_off: 15,
        percentOff: 15,
        redeem_by: null,
    },
    {
        id: "HCP",
        amount_off: null,
        currency: null,
        duration: "forever",
        duration_in_months: null,
        durationInMonths: null,
        max_redemptions: null,
        metadata: {},
        name: "Housecall Pro Integrated Discount",
        percent_off: 15,
        percentOff: 15,
        redeem_by: null,
    },
    {
        id: "TQpHpIZT",
        amount_off: null,
        currency: null,
        duration: "forever",
        duration_in_months: null,
        durationInMonths: null,
        max_redemptions: null,
        metadata: {},
        name: "Surefire Special",
        percent_off: 80,
        percentOff: 80,
        redeem_by: null,
    },
    {
        id: "V4wrI0S6",
        amount_off: null,
        currency: null,
        duration: "once",
        duration_in_months: null,
        durationInMonths: null,
        max_redemptions: null,
        metadata: {},
        name: "30 Day Trial",
        percent_off: 100,
        percentOff: 100,
        redeem_by: null,
    },
    {
        id: "p8EQ3I95",
        amount_off: null,
        currency: null,
        duration: "once",
        duration_in_months: null,
        durationInMonths: null,
        max_redemptions: 1,
        metadata: {},
        name: "Jobber 30 Day Trial",
        percent_off: 100,
        percentOff: 100,
        redeem_by: null,
    },
    {
        id: "kE1mrfAG",
        amount_off: null,
        currency: null,
        duration: "forever",
        duration_in_months: null,
        durationInMonths: null,
        max_redemptions: null,
        metadata: {},
        name: "Marketplace Discount",
        percent_off: 15,
        percentOff: 15,
        redeem_by: null,
    },
    {
        id: "CEJBGdHg",
        amount_off: null,
        currency: null,
        duration: "forever",
        duration_in_months: null,
        durationInMonths: null,
        max_redemptions: null,
        metadata: {},
        name: "LACRM upgrade ",
        percent_off: 40,
        percentOff: 40,
        redeem_by: null,
    },
    {
        id: "Qj2v5POX",
        amount_off: null,
        currency: null,
        duration: "forever",
        duration_in_months: null,
        durationInMonths: null,
        max_redemptions: null,
        metadata: {},
        name: "Mr Ben coupon",
        percent_off: 40,
        percentOff: 40,
        redeem_by: null,
    },
    {
        id: "FbuTz8Ha",
        amount_off: null,
        currency: null,
        duration: "forever",
        duration_in_months: null,
        durationInMonths: null,
        max_redemptions: null,
        metadata: {},
        name: "LACRM Partner Discount 15%",
        percent_off: 15,
        percentOff: 15,
        redeem_by: null,
    },
    {
        id: "QqfPl4w7",
        amount_off: null,
        currency: null,
        duration: "forever",
        duration_in_months: null,
        durationInMonths: null,
        max_redemptions: null,
        metadata: {},
        name: "Housecall Pro",
        percent_off: 15,
        percentOff: 15,
        redeem_by: null,
    },
    {
        id: "WjRlMUEo",
        amount_off: null,
        currency: null,
        duration: "forever",
        duration_in_months: null,
        durationInMonths: null,
        max_redemptions: null,
        metadata: {},
        name: "Jobber Upgrade",
        percent_off: 15,
        percentOff: 15,
        redeem_by: null,
    },
    {
        id: "0u0MycmZ",
        amount_off: null,
        currency: null,
        duration: "repeating",
        duration_in_months: 12,
        durationInMonths: 12,
        max_redemptions: null,
        metadata: {},
        name: "2024 New Customer Promotion",
        percent_off: 15,
        percentOff: 15,
        redeem_by: null,
    },
    {
        id: "service-50",
        amount_off: 5000,
        currency: "usd",
        duration: "once",
        duration_in_months: null,
        durationInMonths: null,
        max_redemptions: null,
        metadata: {},
        name: "Service50",
        percent_off: null,
        percentOff: null,
        redeem_by: null,
    },
    {
        id: "L8cnke3g",
        amount_off: null,
        currency: null,
        duration: "forever",
        duration_in_months: null,
        durationInMonths: null,
        max_redemptions: null,
        metadata: {},
        name: "Jobber Partner Discount",
        percent_off: 15,
        percentOff: 15,
        redeem_by: null,
    },
    {
        id: "v5ueBUAl",
        amount_off: null,
        currency: null,
        duration: "forever",
        duration_in_months: null,
        durationInMonths: null,
        max_redemptions: null,
        metadata: {},
        name: "Annual Plan",
        percent_off: 10,
        percentOff: 10,
        redeem_by: null,
    },
];
